<template>
    <div ref="container">
       <a-modal 
        :title="title" 
        width="95%" 
        :visible="visible" 
        :confirmLoading="confirmLoading" 
        :maskStyle="{'top':'93px','left':'154px'}" 
        :maskClosable="false" 
        @ok="handleOk" 
        @cancel="handleCancel"
        @close="close" 
        cancelText="关闭" 
        style="top:50px;height: 90%;"
        :footer="null"
        >
           <getTrace-code ref="traceCode" :rule-id="getRuleIdFromFather" :product-info="productInfo" :process-id='getProcessId' :craft-id='getCraftId' :metarial-info="getMetarialInfo" :plan-id="getPlanID" :process-code="getProcessCode" @close="closeModal"></getTrace-code>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
import GetTraceCode from '@/views/identifierCode/getTraceCode';
import { traceModuleEdit, traceModuleDetail } from '@/api/api'
export default {
  name: 'CustomerModal',
  components: {
    GetTraceCode
  },
  data () {
    return {
      title: '开始任务',
      visible: false, 
      confirmLoading: false,
      traceVueModule: null,
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
      },
      productInfo: {},
      formModule:[],
      traceModuleForm: {},
      getRuleIdFromFather: '',
      getProcessId: null,
      getCraftId: null,
      getMetarialInfo : null,
      getPlanID : null,
      getProcessCode : null,
    }
  },
    methods: {
        open(data,info,planIdFromCookie,processCodeFromCookie){
          debugger
          console.log(info,'info==========================')
            this.visible = true
            this.productInfo = info
            this.getRuleIdFromFather = data.proceRuleId
            this.getCraftId = data.craftId
            this.getProcessId = data.processId
            this.getMetarialInfo = info.materialId
            this.getPlanID = planIdFromCookie
            this.getProcessCode = processCodeFromCookie
            console.log(data,info, this.getPlanID,this.getRuleIdFromFather,this.getProcessCode,'获取的info==============')
            // 调用子组件的getCodeInfoForCookie方法
            
            this.$nextTick(() => {
              this.$refs.traceCode.getCodeInfoForCookie()
            });
            
            
        },
        show(data){
            this.traceVueModule = data
        },
        add(data) {
          this.traceModuleForm = data
          this.visible = true;
          this.$nextTick(() => {
            if (this.$refs.traceModules && typeof this.$refs.traceModules.showDialog === 'function') {
              this.$refs.traceModules.showDialog(data);
            } else {
              console.error('traceModules 或 showDialog 未正确初始化');
            }
          });
          this.getFormArray(data)
        },
        // 获取表单数据
        async getFormArray(data){
          const res = await traceModuleDetail(data)
          if( res.code == 200 && res.success == true ){
              this.formModule = res.result.formArray
              this.traceVueModule = res.result.formArray
          }
        },
        handleGetDrawingList(drawingList){
          // 在这里处理接收到的 drawingList 数据
          this.formModule = drawingList
        },
        handleOk() {

          this.visible = false;
        },
        handleCancel(){
          console.log('父组件被调用了==========================')
          this.visible = false;
          this.resetCurrentStepInChild();
        },
        close(){
          this.visible = false;
        },
        closeModal(){
          this.visible = false;
        },
        resetCurrentStepInChild() {
          if (this.$refs.traceCode) {
            this.$refs.traceCode.resetCurrentStep();
          }
        }
    }
}
</script>
<style lang="less" scoped>

</style>